import React from 'react';
import styles from "./StepPage.module.scss";
import { Badge, Button, TextButton, Typography } from 'seagull';
import { FooterErrorMessage } from "./FooterErrorMessage";
import { Download, WideArrowBackward } from 'seagull/icons';
import { useResponsive } from "../contexts";
import cn from 'classnames';
import { reasonToText } from "../clientOb/ClientOnboarding.utils";
import { useCobConfig } from "../clientOb/CobConfigContext";
import BrandingControllers from "../clientOb/BrandingControllers/BrandingControllers";
import { OverrideBranding } from "../clientOb/CobBrandingContext";
import { useIoContext, useStore } from "../../contexts";
import { selectors } from "../../store/state-selectors";
import { TextBox } from "./TextBox";
import { getAgreementPdfUrl } from "../../business-logic/relationshipLogic";
import { relationshipModel } from "../../models";
export function StepPage(_ref) {
  let {
    children,
    header,
    primaryBtn,
    onBackBtnClick,
    showError,
    disabledReason,
    contentClassName,
    errorMessage,
    errorTestid,
    backBtnTestid,
    testid,
    showDownloadAsPDFButton = false,
    disableDownloadAsPDFButton = false
  } = _ref;
  const worksAt = useStore(selectors.user.business);
  const {
    isMobile,
    isDesktop
  } = useResponsive();
  const {
    relationship,
    isSetupBrand
  } = useCobConfig();
  const {
    openNewTab
  } = useIoContext();
  const pdfHost = useStore(selectors.pdfHost);
  const onDownloadPDF = () => {
    openNewTab(getAgreementPdfUrl(relationshipModel.id(relationship), pdfHost));
  };
  if (primaryBtn.type === Button) {
    primaryBtn = /*#__PURE__*/React.cloneElement(primaryBtn, {
      fluid: true
    });
  }
  const wrappedPrimaryBtn = isDesktop ? /*#__PURE__*/React.createElement("div", {
    className: styles.ctaWrapper
  }, primaryBtn) : primaryBtn;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": testid,
    className: cn(styles.root, {
      [styles.mobile]: isMobile,
      [styles.desktop]: isDesktop
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.headerAndContent
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement(TextBox, {
    className: styles.headerTextBox
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.title
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: isMobile ? 'h6' : 'h4',
    weight: "normal",
    "data-testid": "".concat(testid, "-header")
  }, header), relationship.isSample && /*#__PURE__*/React.createElement(Badge, {
    outlined: true
  }, "Test agreement")), showDownloadAsPDFButton && /*#__PURE__*/React.createElement(TextButton, {
    onClick: onDownloadPDF,
    className: styles.downloadButton,
    prefixIcon: /*#__PURE__*/React.createElement(Download, {
      height: 16,
      width: 16
    }),
    underline: "none",
    variant: "paragraph2",
    weight: "light",
    "data-testid": "".concat(testid, "-download-pdf"),
    skin: "secondary",
    disabled: disableDownloadAsPDFButton
  }, "Download as PDF"))), /*#__PURE__*/React.createElement("div", {
    className: cn(styles.contentWrapper, contentClassName)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, children))), isSetupBrand && worksAt && /*#__PURE__*/React.createElement(OverrideBranding, {
    className: styles.setupBrandContainer,
    testid: "setup-brand-section"
  }, /*#__PURE__*/React.createElement(BrandingControllers, {
    worksAt: worksAt
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.footer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.primaryBtnContainer
  }, errorMessage ? /*#__PURE__*/React.createElement(FooterErrorMessage, {
    vertical: isMobile,
    showError: showError !== null && showError !== void 0 ? showError : false,
    errorMessage: errorMessage,
    "data-testid": errorTestid
  }, wrappedPrimaryBtn) : wrappedPrimaryBtn, disabledReason && /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "disabled-reason-".concat(disabledReason),
    className: styles.disabledReason
  }, reasonToText[disabledReason])), isDesktop && onBackBtnClick && /*#__PURE__*/React.createElement(TextButton, {
    skin: "secondary",
    prefixIcon: /*#__PURE__*/React.createElement(WideArrowBackward, null),
    underline: "hover",
    onClick: onBackBtnClick,
    "data-testid": backBtnTestid
  }, "Back")));
}